<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="'Dimension Group -'+modalData.initName"
        :show-close="false"
        width="650px"
        append-to-body
        destroy-on-close
        :before-close="handleClose">
        <div>
            <el-form ref="form" :model="formItem" :rules="rules" label-width="150px" class="pr40" :disabled="modalData['type'] == 'info'">
                <el-form-item label="Name" prop="display_name">
                    <el-input v-model.trim="formItem.display_name" maxlength="20" show-word-limit placeholder="Please enter "
                        style="width:230px;" clearable />
                </el-form-item>
                <el-form-item v-if="modalData.name=='date'" prop="sum_type" label="Summary method" class="label-required">
                    <el-select v-model="formItem.sum_type" @change="changeSumType" placeholder="Please select">
                        <el-option label="Day" value="day"></el-option>
                        <el-option label="Week" value="week"></el-option>
                        <el-option label="Month" value="month"></el-option>
                        <el-option label="Quarter" value="quarter"></el-option>
                        <el-option label="Year" value="year"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="modalData.name=='yy_type'" prop="start_date_dimension" label="Operation Type Dimension" class="label-required">
                    <el-select v-model="formItem.yy_type_dimension" @change="checkAppleSelect" placeholder="Please select">
                        <el-option
                            v-for="item in yyTypeDimensionList"
                            :key="item.name"
                            :label="item.display_name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="modalData.name=='start_date'" prop="start_date_dimension" label="Start Date Dimension" class="label-required">
                    <el-select v-model="formItem.start_date_dimension" @change="checkAppleSelect" placeholder="Please select">
                        <el-option
                            v-for="item in dimensionList"
                            :key="item.name"
                            :label="item.display_name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-else-if="modalData.name=='create_date'" prop="create_date_dimension" label="Creation Date Dimension" class="label-required">
                    <el-select v-model="formItem.create_date_dimension" @change="checkAppleSelect" placeholder="Please select">
                        <el-option
                            v-for="item in createDimensionList"
                            :key="item.name"
                            :label="item.display_name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Sorting conditions" prop="order_by" :class="modalData.name=='date'?'label-required':''">
                    <el-select v-model="formItem.order_by" @change="changeOrderBy" @clear="clearOrderBy" clearable filterable placeholder="Please select">
                        <el-option value="date" label="Data Date" v-if="modalData.name=='date'"></el-option>
                        <el-option
                            v-for="item in availableFieldList"
                            :key="item.name"
                            :label="item.display_name"
                            :disabled="isCompare&&item.isSumField"
                            :title="isCompare&&item.isSumField?'Dimension sorting when comparing cumulative metrics':''"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <template v-if="modalData.name=='date'||formItem.order_by">
                    <el-form-item label="Sort Order" prop="order_type" class="label-required">
                        <el-radio v-model="formItem.order_type" label="desc">Desc</el-radio>
                        <el-radio v-model="formItem.order_type" label="asc">Asc</el-radio>
                    </el-form-item>
                    <el-form-item v-if="modalData.name!='date'" label="Display quantity" prop="show_num" class="label-required">
                        <el-radio v-model="formItem.show_type" label="1">All</el-radio>
                        <el-radio v-model="formItem.show_type" label="2">Custom<span v-if="formItem.show_type==2" class="pl6 text-color-gray">Enter the number of displays</span></el-radio>
                        <p class="ml80">
                            <el-input-number v-if="formItem.show_type=='2'" v-model="formItem.show_num" size="mini" controls-position="right" :min="1" :step="1" placeholder="Enter the number of displays"></el-input-number>
                        </p>
                    </el-form-item>
                </template>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">Cancel</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">Submit</el-button>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "DimensionModal",
        components: {},
        props: {
            modalData:{  
                type:Object, 
                required:true,
            },
            shownField:{
                type:Array,
                required: true,
            },
            hiddenField:{
                type:Array,
                required: true,
            },
            dimensions:{
                type:Array,  //选中维度
                required: true,
            },
            allField:{
                type:Array,  //全部指标
                required: true,
            },
            platId:[String,Number],
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            },
            isCompare:{
                required: false,
                type:Boolean,
                default:false,
            },
            allDimensions: {
                type:Array,  //全部维度
                required: true,
            },
            selectTarget: {
                type:Array,  //选中指标
                required: true,
            }
        },
        data() {
            return {
                dialogVisible: false,
                formItem: {
                    sum_type:'',    // 汇总方式
                    start_date_dimension:'app_name',        //开投日期维度:取维度字段，默认按产品
                    create_date_dimension:'account_create_time',        //创建日期维度:取维度字段
                    yy_type_dimension:'bloc_yy_type',       // 运营类型维度:取维度字段
                    order_by:'',    // 排序条件
                    order_type:'desc',    // 排序方式
                    show_type:'1',    // 展示数量方式 1-全部，2-自定义
                    show_num:null,    // 展示数量
                    display_name: '' // 维度名称
                },
                rules: {
                    sum_type: [],
                    start_date_dimension: [],
                    order_by: [],
                    order_type: [],
                    show_num: [],
                    display_name: [
                        { required: true, message: 'Please enter name', trigger: 'blur' }
                    ],
                },
                dimensionList:[],
                createDimensionList:[],
                yyTypeDimensionList:[],
                allFieldList:[],
                lastSelectVal:'',
            }
        },
        computed: {
            availableFieldList(){
                if(!this.isTimeFilter) return this.allFieldList;
                if(this.isCompare&&!this.isTimeFilter){
                    return this.allFieldList;
                }
                console.log('---', this.allFieldList.filter(field=>((field.config||{}).time_type||[]).includes('hour')))
                return this.allFieldList.filter(field=>((field.config||{}).time_type||[]).includes('hour'));
            },
        },
        watch: {
            dialogVisible(n) {
                if (!n) {
                    window.removeEventListener('keydown', this.keydownFn)
                }else {
                    window.addEventListener('keydown', this.keydownFn);
                }
            }
        },
        methods: {
            keydownFn(e) {
                 if (e.keyCode === 13) {
                    this.handleSubmit()
                }
            },
            handleClose() {
                this.dialogVisible = false;
                this.$nextTick(()=>{
                    this.resetForm();
                })
            },
            resetForm() {
                this.formItem.sum_type = '';
                this.formItem.start_date_dimension = 'app_name';
                this.formItem.create_date_dimension = this.platId=='9'?'plan_create_date':'account_create_time';
                this.formItem.yy_type_dimension = 'bloc_yy_type';
                this.formItem.order_by = '';
                this.formItem.order_type = 'desc';
                this.formItem.show_type = '1';
                this.formItem.show_num = null;
                this.formItem.display_name = ''
                this.$refs['form'].resetFields();
            },
            makeDimensionList(){
                this.dimensionList = [
                    {
                        display_name:'By Group',
                        name:'bloc_name',
                    },
                    {
                        display_name:'By Client',
                        name:'company_name',
                    },
                    {
                        display_name:'By Campaign Group',
                        name:'account_name',
                    },
                    {
                        display_name:'By Project',
                        name:'project_name',
                    },
                    {
                        display_name:'By Sub Project',
                        name:'subproject_name',
                    },
                    {
                        display_name:'By Product',
                        name:'app_name',
                    },
                    {
                        display_name:'By Campaign',
                        name:'plan_name',
                    },
                    {
                        display_name:'By Ad Group',
                        name:'adgroup_name',
                    },
                    {
                        display_name:'By Keyword',
                        name:'keyword',
                    },
                    {
                        display_name:'By Search Term',
                        name:'search_term',
                    },
                    {
                        display_name:'By Ad',
                        name:'ad_name',
                    },
                ].filter(item=>{
                    if(this.isTimeFilter){
                        return item.name!='search_term'&&item.name!='ad_name'&&item.name!='ad_create_date';
                    }else{
                        return true;
                    }
                });
                this.createDimensionList = [
                    {
                        display_name:'By Campaign',
                        name:'plan_create_date',
                    },
                    {
                        display_name:'By Ad Group',
                        name:'adgroup_create_date',
                    },
                    {
                        display_name:'By Keyword',
                        name:'keyword_create_date',
                    },
                    {
                        display_name:'By Ad',
                        name:'ad_create_date',
                    },
                ].filter(item=>{
                    if(this.isTimeFilter){
                        return item.name!='search_term'&&item.name!='ad_name'&&item.name!='ad_create_date';
                    }else{
                        return true;
                    }
                });
                this.yyTypeDimensionList = [
                    {
                        display_name:'By Group',
                        name:'bloc_yy_type',
                    },
                    {
                        display_name:'By Client',
                        name:'company_yy_type',
                    },
                    {
                        display_name:'By Campaign Group',
                        name:'account_yy_type',
                    },
                    {
                        display_name:'By Project',
                        name:'project_yy_type',
                    },
                    {
                        display_name:'By Sub Project',
                        name:'subproject_yy_type',
                    },
                    {
                        display_name:'By Product',
                        name:'app_yy_type',
                    },
                    {
                        display_name:'By Campaign',
                        name:'plan_yy_type',
                    },
                    {
                        display_name:'By Ad Group',
                        name:'adgroup_yy_type',
                    },
                    {
                        display_name:'By Keyword',
                        name:'keyword_yy_type',
                    },
                ];
            },
            showModal() {
                this.dialogVisible = true;
                this.makeDimensionList();
                console.log('this.modalData.order_by', this.modalData.order_by, this.modalData)
                this.formItem.sum_type = this.modalData.name=='date'?this.modalData.sum_type:'';
                this.formItem.start_date_dimension = this.modalData.name=='start_date'?this.modalData.start_date_dimension||'app_name':'';
                this.formItem.create_date_dimension = this.modalData.name=='create_date'?this.modalData.create_date_dimension||'account_create_time':'';
                this.formItem.yy_type_dimension = this.modalData.name=='yy_type'?this.modalData.yy_type_dimension||'bloc_yy_type':'';
                this.formItem.order_by = this.modalData.order_by||(this.modalData.name=='date'?'date':this.modalData.name=='time_interval'?'time_interval':'');
                this.formItem.order_type = this.modalData.order_type||'desc';
                this.formItem.show_type = this.modalData.show_type||'1';
                this.formItem.show_num = this.modalData.show_num||null;
                this.formItem.display_name = this.modalData.display_name||'';

                if(this.modalData.name=='start_date'){
                    this.lastSelectVal = this.formItem.start_date_dimension;
                }else if(this.modalData.name=='create_date'){
                    this.lastSelectVal = this.formItem.create_date_dimension;
                }else if(this.modalData.name=='yy_type'){
                    this.lastSelectVal = this.formItem.yy_type_dimension;
                }
                

                this.$nextTick(()=>{
                    let checkedData = [...this.selectTarget]
                    let flatData = [];
                    this.allField.forEach(item => {
                        if (item.children && item.children.length > 0) {
                            flatData = flatData.concat(item.children.map(inner=>{
                                if(item.name.includes('_sum_data')){
                                    inner.isSumField = true;
                                }
                                return inner;
                            }));
                        }
                    });
                    flatData.forEach(item=>{
                        checkedData.map(itemc=>{
                            if(itemc['name'] == item['name']) {
                                itemc['display_name'] = item['display_name']
                            }
                            return itemc
                        })
                        if(checkedData.findIndex(inner=>inner.name==item.name)===-1){
                            checkedData.push(item);
                        }
                    });

                    this.allFieldList = checkedData;
                })
            },
            handleSubmit() {
                if(this.modalData && this.modalData['type'] == 'info') {
                    this.$nextTick(()=>{
                        this.handleClose();
                    })
                    return
                }
                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        let dimensionSortCount = 0;
                        this.dimensions.filter(item=>item.name!=this.modalData.name).forEach(item=>{
                            if(item.name==='date'||item.name==='time_interval'){
                                dimensionSortCount++
                            }else{
                                if(item.order_by!=''){
                                    dimensionSortCount++
                                }
                            }
                        });

                        //全部维度
                        let is_equal_all_dimensions = this.allDimensions.some(item=>{
                            let r_boolean = false
                            item['children'] && item['children'].forEach(el=>{
                                if(el['name'] != this.modalData['name'] && el['display_name'] == this.formItem.display_name) {
                                    r_boolean = true
                                }
                            })
                            return r_boolean
                        })

                        //选中维度
                        let is_equal_select_dimensions = this.dimensions.filter(item=>item['name'] != this.modalData['name']).some(item=>item['display_name'] == this.formItem.display_name)

                        //全部指标
                        let is_equal_all_target = this.allFieldList.some(item=>item['display_name'] == this.formItem.display_name)
                        //选中指标
                        let is_equal_select_target = this.selectTarget.some(item=>item['display_name'] == this.formItem.display_name)

                        // console.log('全部维度', is_equal_all_dimensions)
                        // console.log('选中维度', is_equal_select_dimensions)
                        // console.log('全部维度', is_equal_all_target)
                        // console.log('选中维度', is_equal_select_target)

                        if(this.formItem.order_by&&dimensionSortCount>10){
                            return this.$message.error('Up to 10 dimensions can be set for sorting');
                        }

                        if(this.formItem.display_name == ''){
                            return this.$message.error('The name is required');
                        }

                        if(is_equal_all_dimensions || is_equal_select_dimensions || is_equal_all_target || is_equal_select_target){
                            return this.$message.error('The name is duplicated. Please modify~');
                        }


                        let data={
                            order_by: this.formItem.order_by,
                            order_type: this.formItem.order_by?this.formItem.order_type:'',
                            show_num: this.formItem.order_by?this.formItem.show_num:'',
                            show_type: this.formItem.order_by?this.formItem.show_type:'',
                            start_date_dimension:this.formItem.start_date_dimension,
                            create_date_dimension:this.formItem.create_date_dimension,
                            yy_type_dimension:this.formItem.yy_type_dimension,
                            sum_type: this.formItem.sum_type,
                            name: this.modalData['name'],
                            // display_name: this.modalData['display_name'],
                            display_name: this.formItem.display_name
                 
                        };
                        console.log('data', data)
                        this.$emit('save-value', data);
                        this.$nextTick(()=>{
                            this.handleClose();
                        })
                    } else {
                        return false;
                    }
                });
            },
            clearOrderBy(){
                if(this.modalData.name=='date'){
                    this.formItem.order_by = 'date';
                }else if(this.modalData.name=='time_interval'){
                    this.formItem.order_by = 'time_interval';
                }
            },
            changeOrderBy(val){
                /* 判断维度中有排序的个数，超过10个后禁止设置 */

                console.log('-', this.dimensions)

                let dimensionSortCount = 0;
                this.dimensions.filter(item=>item.name!=this.modalData.name).forEach(item=>{
                    if(item.name==='date'||item.name==='time_interval'){
                        dimensionSortCount++
                    }else{
                        if(item.order_by != ''){
                            dimensionSortCount++
                        }
                    }
                });
                if(val&&dimensionSortCount>=10){
                    this.$message.error('Up to 10 dimensions can be set for sorting');
                    if(this.modalData.name!='date'&&this.modalData.name!='time_interval'){
                        this.formItem.order_by = '';
                    }
                }
            },
            changeSumType(){
                // this.$emit('change-sum-type');
            },
            checkAppleSelect(val){
                if(this.platId!='9') return false;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body{
        padding: 20px;
    }

</style>
